import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Accordion, Button, Typography } from '@tkww/the-bash-frontend';

import { SectionContainer } from 'components/grid';

const FAQ = ({ faqEntries, onViewed }) => {
  const theme = useTheme();
  return (
    <SectionContainer
      backgroundColor={theme.palette.grey[200]}
      containerProps={{ sx: { pt: 7, pb: 7, display: 'flex', flexDirection: 'column' } }}
    >
      <Typography variant="h2" textAlign="center" mt={0} mb={4}>
        Frequently Asked Questions
      </Typography>
      {faqEntries.map((faqEntry) => (
        <Accordion
          key={faqEntry.id}
          id={`question-${faqEntry.slug}`}
          details={<p dangerouslySetInnerHTML={{ __html: faqEntry.answer }} />}
          summary={faqEntry.question}
          handleOnChange={() => onViewed(faqEntry)}
        />
      ))}
      <Button href="/help" type="primary" sx={{ margin: 'auto', textTransform: 'uppercase' }}>
        See All Questions
      </Button>
    </SectionContainer>
  );
};

FAQ.propTypes = {
  faqEntries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FAQ;
